// @flow
import _ from 'lodash/fp';
import React, {Component} from 'react';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import {connect} from 'react-redux';
import {
  toggleDialog,
} from '../../actions/actionConfirmation';
import './ActionConfirmation.css';
const reduceWithKey = _.reduce.convert({cap: false});
import type {Element} from 'react';

export type Props = {
  message?: string,
  messages?: Array<string>,
  id: string,
  className?: string,
  buttonText?: string,
  action: Function,
  actionConfirmation: Object,
  toggleDialog: Function,
  wrapperClassName?: string,
  children?: number | string | Element<*> | Array<any>,
};

class ActionConfirmation extends Component<Props> {
  props: Props;

  componentWillUnmount() {
    this.props.toggleDialog(this.props.id, false);
  }

  render() {
    const {
      id,
      action,
      actionConfirmation,
      toggleDialog,
      className = '',
      buttonText,
      message = null,
      messages = [],
      wrapperClassName = '',
      children,
    } = this.props;

    return (
      <div className={`ActionConfirmation ${wrapperClassName}`}>
        <button
          className={`button ${className}`}
          type="button"
          onClick={() => toggleDialog(id, true)}>
          {children || buttonText}
        </button>
        <ModalDialog
          onClose={() => toggleDialog(id, false)}
          className="ActionConfirmationDialog"
          show={!!actionConfirmation[id]}>
          <div className="callout warning text-center">
            <p>{!!message
              ? message
              : !!messages.length
                ? reduceWithKey((x, y, i) => !!x.length ? [...x, <br key={i}/>, y] : [y], [], messages)
                : 'Är du säker?'
            }</p>
          </div>
          <button
            type="button"
            className="expanded success button"
            onClick={() => {
              toggleDialog(id, false);
              action();
            }}>
            Ja
          </button>
          <button
            type="button"
            className="expanded button"
            onClick={() => toggleDialog(id, false)}>
            Avbryt
          </button>
        </ModalDialog>
      </div>
    );
  }
}

const mapStateToProps = ({
  actionConfirmation,
}) => ({
  actionConfirmation,
});

const mapDispatchToProps = dispatch => ({
  toggleDialog: (id, show) =>
    dispatch(toggleDialog(id, show)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionConfirmation);



// WEBPACK FOOTER //
// ./src/containers/ActionConfirmation/ActionConfirmation.js